import moment from "moment";

import Uptime from "./components/Uptime";
import Tooltip from "components/ToolTip";

import priceRender from "libs/helpers/priceRender";

import { ReactComponent as SummaryIcon } from "assets/icons/new/summary.svg";
import { ReactComponent as PlanIcon } from "assets/icons/new/plan.svg";
import { ReactComponent as MonitorIcon } from "assets/icons/new/monitor.svg";
import { ReactComponent as QuestionIcon } from "assets/icons/new/question-icon.svg";

const getListItems = (data, uptime, t) => {
  const sslValidDays = data?.ssl_valid_until
    ? moment(data.ssl_valid_until).diff(moment(), "days")
    : null;

  const averageResponseTime =
    uptime?.items?.reduce((total, item) => {
      return total + Number.parseInt(item.response_time, 10);
    }, 0) / uptime?.items?.length;

  const uptimeStatus =
    uptime?.items?.[uptime?.items?.length - 1]?.status === 404
      ? "Offline"
      : "Online";

  const overviewData = [
    {
      label: t("Uptime monitoring"),
      value: t(uptimeStatus),
    },
    {
      label: t("Last CMS update"),
      value: data?.last_cms_update
        ? moment(data.last_cms_update).format("ll")
        : "-",
    },
    {
      label: t("SSL certificate valid until"),
      value: data?.ssl_valid_until
        ? moment(data.ssl_valid_until).format("ll")
        : "-",
      days_left:
        sslValidDays !== null
          ? sslValidDays > 0
            ? `${t("Expires in")} ${sslValidDays} ${t("days")}.`
            : `${t("Expired")} ${moment(data.ssl_valid_until).fromNow()}`
          : null,
    },
    {
      label: t("Domain valid until"),
      value: data?.domain_valid_until
        ? moment(data.domain_valid_until).format("ll")
        : "-",
    },
  ];

  const planData = [
    {
      label: t("Type"),
      value: data?.subscription?.name || "-",
    },
    {
      label: t("Billing cycle"),
      value: data?.subscription?.contract_period
        ? t(data.subscription.contract_period)
        : "-",
    },
    {
      label: t("Amount"),
      value: data?.subscription?.amount
        ? priceRender(
            data.subscription.amount / 100,
            data.subscription.currency,
          )
        : "-",
    },
    {
      label: t("Next charge"),
      value: data?.subscription?.next_payment
        ? moment.unix(data.subscription.next_payment).format("ll")
        : "-",
    },
  ];

  return [
    {
      icon: <SummaryIcon />,
      title: t("Summary"),
      description: t("Check detailed technical data."),
      content: overviewData,
    },
    {
      icon: <PlanIcon />,
      title: t("Plan"),
      description: t("Learn more about your currently purchased plan."),
      content: planData,
    },
    {
      icon: <MonitorIcon />,
      aside: (
        <Tooltip
          position="left"
          text={`${t("Average response time of the site from the last 24 hours:")} ${
            averageResponseTime || 0
          } ms.`}
        >
          <QuestionIcon />
        </Tooltip>
      ),
      title: t("Website performance monitoring"),
      description: t("See how your site is performing."),
      component: <Uptime data={uptime} period="day" />,
    },
  ];
};

export { getListItems };
